<script setup lang="ts">
import { PrimaryButton } from "#components"
import { SecondaryButton } from "#components"
const router = useRouter()
const props = withDefaults(
    defineProps<{
        to: string
        primary?: boolean
        titleKey?: string
    }>(),
    {
        primary: true,
        titleKey: "actions.cancel",
    }
)
const navigate = () => {
    router.push({
        path: props.to,
    })
}
</script>

<template>
    <component
        :is="primary ? PrimaryButton : SecondaryButton"
        @click.prevent="navigate"
    >
        {{ $t(titleKey) }}
    </component>
</template>

<style scoped></style>
